import configData from "./AppConfig.json";

// Brand options
export const BRAND_DEFAULT = "Default";
export const BRAND_CENTENARY = "Centenary";
export const BRAND_LYSAGHT = "Lysaght";

// Extract URL and query parameters
const url = document.location.href.split("?")[0];
const params = new URLSearchParams(document.location.search);

// Determine debug mode
const isDebugEnv = [/localhost/gi, /192\.168\./g, /hi-ar\.azurewebsites\.net/gi].some((pattern) =>
    pattern.test(document.location.href)
);

export const APP_DEBUG = isDebugEnv;

// Determine the brand
function getBrand() {
    if (/centenary/gi.test(url)) return BRAND_CENTENARY;
    if (/lysaght/gi.test(url)) return BRAND_LYSAGHT;

    if (APP_DEBUG && params.has("brand")) {
        const brandParam = params.get("brand").toLowerCase();
        if (brandParam === BRAND_CENTENARY.toLowerCase()) return BRAND_CENTENARY;
        if (brandParam === BRAND_LYSAGHT.toLowerCase()) return BRAND_LYSAGHT;
    }

    return BRAND_DEFAULT;
}

export const APP_BRAND = getBrand();

// Determine API environment
let apiEnv;

if (APP_DEBUG) {
    apiEnv = "debug";
} else if (/test\./gi.test(url)) {
    apiEnv = "test";
} else if (/preprod\./gi.test(url)) {
    apiEnv = "preprod";
} else {
    apiEnv = "live";
}

export const APP_API = configData.Api[apiEnv];

// Get job ID
export const APP_JOB = params.get("job") || "";

// Determine the model URL
export const APP_MODEL = (() => {
    if (params.has("model") && APP_DEBUG) {
        return params.get("model");
    }

    if (APP_JOB) {
        return `${APP_API}${APP_JOB}`;
    }

    return "";
})();

// Initialize document title
export function initDoc() {
    document.title = `${configData.Brand[APP_BRAND].name} - 3D Model`;
}
